import Axios from "axios";
import { SETTINGS } from "../../properties/ApiProps";

export const VacancyAppRepository = {
  create: (data) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications`,
      method: "POST",
      data: data,
    });
  },
  updateStatus: (id, status, comment, additionalDataDueDatePlusDays) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${id}/updateStatus`,
      method: "POST",
      params: {
        status: status,
        comment: comment,
        additionalDataRequiredDueDatePlusDays: additionalDataDueDatePlusDays,
      },
    });
  },
  get: (id) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${id}`,
      method: "GET",
    });
  },
  getAll: (payload) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications`,
      method: "GET",
      params: {
        page: payload.page,
        size: payload.size,
        orderBy: payload.orderBy,
        orderDirection: payload.orderDirection,
        filterBy: payload.filterBy,
        filterValue: payload.filterValue,
      },
    });
  },
  getAllForPreview: (payload) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/forPreview`,
      method: "GET",
      params: {
        vacancyId: payload.vacancyId,
        firstName: payload.firstName,
        lastName: payload.lastName,
      },
    });
  },
  getAllForAllotment: (payload) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/forAllotment`,
      method: "GET",
      params: {
        vacancyId: payload.vacancyId,
      },
    });
  },

  getAllAssigned: (payload) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/allAssignedByVacancyId`,
      method: "GET",
      params: {
        vacancyId: payload.vacancyId,
      },
    });
  },

  allAdditionalDataRequiredByVacancyId: (payload) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/allAdditionalDataRequiredByVacancyId`,
      method: "GET",
      params: {
        vacancyId: payload.vacancyId,
      },
    });
  },

  getAllForEvaluation: (payload) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/forEvaluation`,
      method: "GET",
      params: {
        page: payload.page,
        size: payload.size,
        orderBy: payload.orderBy,
        orderDirection: payload.orderDirection,
        filterProperty: payload.filterBy,
        filterValue: payload.filterValue,
      },
    });
  },
  getAllByCurrentUser: (payload) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/myVacancyApplications`,
      method: "GET",
      params: {
        page: payload.page,
        size: payload.size,
        orderBy: payload.orderBy,
        orderDirection: payload.orderDirection,
        filterProperty: payload.filterBy,
        filterValue: payload.filterValue,
      },
    });
  },
  getAllByCurrentUserAndVacancyId: (vacancyId) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/myVacancyApplications/${vacancyId}`,
      method: "GET",
    });
  },
  addBasicInfo: (id, data) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${id}/basicInfo`,
      method: "POST",
      data: data,
    });
  },
  getBasicInfo: (id) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${id}/basicInfo`,
      method: "GET",
    });
  },

  downloadFile: (attachmentId, vacancyAppId) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${vacancyAppId}/attachments/${attachmentId}`,
      method: "GET",
    });
  },

  beginAllotment: (data) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/beginAllotment`,
      method: "PUT",
      data: data,
    });
  },

  transferVacancyApp: (vacancyApplicationId, commissionId) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/transfer/${vacancyApplicationId}/${commissionId}`,
      method: "PUT",
    });
  },

  printVacancyApp: (vacancyApplicationId) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/print/${vacancyApplicationId}`,
      method: "GET",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "arraybuffer",
    });
  },

  printOriginalVacancyApp: (vacancyApplicationId) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/print/originalDoc/${vacancyApplicationId}`,
      method: "GET",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "arraybuffer",
    });
  },

  verifyVacancyApp: (vacancyApplicationToken) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyAppDocs/verify`,
      method: "POST",
      params: {
        token: vacancyApplicationToken,
      },
    });
  },

  getVacancyAppByToken: (vacancyApplicationToken) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyAppDocs/getDocument`,
      method: "POST",
      params: {
        documentUrlToken: vacancyApplicationToken,
      },
    });
  },
  exportApplicationsToExcel: (vacancyId, type) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/exportToExcel`,
      method: "GET",
      params: {
        vacancyId: vacancyId,
        type: type,
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "arraybuffer",
    });
  },
  getAllVacancyAppsFulfillingConditions: (vacancyId) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/conditionsFulfilled`,
      method: "GET",
      params: {
        vacancyId: vacancyId,
      },
    });
  },
  uploadFile: (vacancyId, file) => {
    const data = new FormData();
    data.append("file", file);
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/updateExcelFile/${vacancyId}`,
      method: "PUT",
      data: data,
    });
  },
  getRankListForVacancy: (vacancyId) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/rankLists/${vacancyId}`,
      method: "GET",
    });
  },
};
